import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";

import { TarifaPagoChoferList } from "./list/list";
import { TarifaPagoChoferEdit } from "./edit/edit";

export class TarifaPagoChoferCatalogo extends React.Component<{match: match<{}>}> {
    render() {
       const path = this.props.match.url;
        return (
            <div>
                <Route exact path={path}  component={TarifaPagoChoferList} />
                <Route path={path + "/:id"}  component={TarifaPagoChoferEdit} />
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./app/features/general/catalogos/items/tarifapagochofer/index.tsx